import React, { useState } from "react";
import { Modal, Box, TextField, Grid, Button } from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCheckCircle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

const SuccessErrorDialog = ({ type, message, open, handleClose, props }) => {

    return (
        <>
            <div className="glocy_modal">
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                    className='glocy_modal'
                >

                    <Box
                        className='glocy_modal_box'
                    >
                        <div className={type == 'success' ? "success_icon" : "error_icon"}>
                            <FontAwesomeIcon icon={message != null ? faCheckCircle : faExclamationCircle} />
                        </div>
                        <div className="modal_head" style={{ textAlign: "right" }}>
                            <FontAwesomeIcon icon={faXmark} onClick={handleClose} />
                        </div>
                        <div className="glocy_modal_container">
                            <h1>{type == 'success' ? 'Success!': 'Error!'}</h1>
                            <p>{message}</p>
                            <Button className="glocy_modal_btn" variant="contained" onClick={handleClose}>Continue</Button>
                        </div>
                    </Box>

                </Modal>
            </div>
        </>
    )
};
export default SuccessErrorDialog;